'use strict'

import React from 'react'
import PropTypes from 'prop-types'

class LiveChatOverlay extends React.PureComponent {

  state = {
    text: '',
  }

  handleChange = (e) => {
    this.setState({ text: e.target.value })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const { text } = this.state
    if (!text.trim()) return
    this.props.onSend(text.trim())
    this.setState({ text: '' })
  }

  handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      this.handleSubmit(e)
    }
  }

  render() {
    const { messages } = this.props
    const { text } = this.state
    const msgList = messages && messages.toJS ? messages.toJS() : (messages || [])
    const recentMessages = msgList.slice(-20)

    return (
      <div style={{ position: 'absolute', bottom: '16px', left: '16px', width: '280px', zIndex: 20, display: 'flex', flexDirection: 'column', gap: '4px' }}>
        {/* Message list */}
        <div style={{ maxHeight: '200px', overflow: 'hidden', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
          {
            recentMessages.map((msg, i) => {
              const age = Date.now() - (msg.timestamp || 0)
              const opacity = age > 10000 ? 0.4 : age > 5000 ? 0.7 : 1

              return (
                <div
                  key={msg.id || i}
                  style={{
                    padding: '3px 8px',
                    borderRadius: '12px',
                    background: 'rgba(0,0,0,0.5)',
                    marginBottom: '2px',
                    maxWidth: '100%',
                    opacity,
                    transition: 'opacity 0.5s',
                  }}
                >
                  <span style={{ color: '#4ade80', fontSize: '12px', fontWeight: '600', marginRight: '6px' }}>
                    {msg.name}
                  </span>
                  <span style={{ color: '#fff', fontSize: '13px', wordBreak: 'break-word' }}>
                    {msg.text}
                  </span>
                </div>
              )
            })
          }
        </div>

        {/* Input */}
        <form onSubmit={this.handleSubmit} style={{ display: 'flex', gap: '4px' }}>
          <input
            type="text"
            value={text}
            onChange={this.handleChange}
            onKeyDown={this.handleKeyDown}
            placeholder="Say something..."
            maxLength={200}
            style={{
              flex: 1,
              padding: '8px 12px',
              borderRadius: '20px',
              border: 'none',
              background: 'rgba(255,255,255,0.15)',
              color: '#fff',
              fontSize: '13px',
              outline: 'none',
              backdropFilter: 'blur(4px)',
            }}
          />
          <button
            type="submit"
            style={{
              background: 'rgba(255,255,255,0.2)',
              border: 'none',
              borderRadius: '50%',
              width: '36px',
              height: '36px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              color: '#fff',
              fontSize: '14px',
              flexShrink: 0,
            }}
          >
            ➤
          </button>
        </form>
      </div>
    )
  }
}

LiveChatOverlay.propTypes = {
  messages: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onSend: PropTypes.func.isRequired,
}

export default LiveChatOverlay
